<h2 class="pb-[2.5rem]">{{ 'personalizedJourney.title' | transloco }}</h2>
<p>{{ 'personalizedJourney.description' | transloco }}</p>
@if (loading()) {
<div class="my-[6.25rem]"><loader /></div>
} @else if (filters().length > 0) {
<div class="flex flex-col gap-10 mb-10">
  <app-filter-section
    [filterType]="branchesFilters().filterSetType"
    [filtersSelectedInput]="branchesFiltersSelected()"
    [name]="branchesFilters().localName"
    [filter]="branchesFilters()"
    [disabled]="isJourneyImmature()"
    (isEmpty)="onBranchesEmpty($event)"
    (updateFiltersSelected)="updateFiltersSelected($event)"
  />
  @if (isActivityFilterUsed()) {

  <app-filter-section
    [filterType]="activitiesFilters().filterSetType"
    [filtersSelectedInput]="activitiesFiltersSelected()"
    [name]="activitiesFilters().localName"
    [filter]="activitiesFilters()"
    [disabled]="isJourneyImmature()"
    (isEmpty)="onActivitiesEmpty($event)"
    (updateFiltersSelected)="updateFiltersSelected($event)"
  ></app-filter-section>
  }
  <app-filter-subsection
    [filterType]="localisationFilters().filterSetType"
    [filtersSelectedInput]="locationFiltersSelected()"
    [name]="localisationFilters().localName"
    [filter]="localisationFilters()"
    [disabled]="isJourneyImmature()"
    (isEmpty)="onLocalisationsEmpty($event)"
    (updateFiltersSelected)="updateFiltersSelected($event)"
  >
  </app-filter-subsection>
</div>
<div class="flex flex-col md:flex-row gap-6 justify-end mb-[2.5rem]">
  <div class="bg-white items-center flex gap-2 px-4 py-2 rounded-lg">
    <input
      type="checkbox"
      id="journey-is-mature"
      name="journey-is-mature"
      class="h-5 w-5 rounded text-vinciBlue-500 focus:ring-vinciBlue-300 hover:cursor-pointer"
      (change)="isJourneyImmature.set($event.target.checked)"
    />
    <label for="journey-is-mature" class="hover:cursor-pointer"
      >{{ 'personalizedJourney.immatureText' | transloco }}</label
    >
  </div>
  <app-button
    [text]="'components.filterButton.saveSearch' | transloco"
    [icon]="isFavoriteSearchSuccessSaved() ? 'thumb-up-filled' : 'thumb-up'"
    [variant]="isFiltersEmpty() ? 'secondary' :'primary'"
    [disabled]="isFiltersEmpty() || isFavoriteSearchSuccessSaved()"
    (buttonClick)="openAddFavoriteModal()"
  ></app-button>
  <app-button
    [text]="'personalizedJourney.submitButtonText' | transloco"
    [icon]="'arrow-right'"
    [variant]="'secondary'"
    [disabled]="!canSearchJourney()"
    (click)="launchJourneySearch()"
  ></app-button>
</div>

@if (isAddToFavoriteModalOpen()) {
<app-input-modal
  [title]="'components.addFavoriteFilterModal.Title' | transloco"
  [text]="'components.addFavoriteFilterModal.Text' | transloco"
  [inputTitle]="'components.addFavoriteFilterModal.PersonnalizedLabel' | transloco"
  [buttonText]="'components.addFavoriteFilterModal.CtaText' | transloco"
  [placeholder]="'components.addFavoriteFilterModal.PlaceholderText' | transloco"
  (completeModal)="saveSearch($event)"
  (closeModal)="closeAddFavoriteModal()"
></app-input-modal>
} }

<app-favorite-search-error-modal />
